import { FC, useRef } from 'react'
import { useRadio } from '@chakra-ui/react'
import { Box, Text } from '../index'
import { RadioButtonProps } from './interfaces'
import theme from '../../styles'
import { RadioButton } from './radio-button'

export const MainPillRadioButton: FC<RadioButtonProps> = (props) => {
  const { getInputProps, getRadioProps } = useRadio({ ...props, value: props.value?.toString() })
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  return (
    <Box as="label" cursor="pointer" data-testid={`pill-${props.value}`}>
      <Box
        {...getRadioProps()}
        tabIndex={0}
        onFocus={handleFocus}
        layerStyle={theme.LayerStyles.MAIN_PILL}
        aria-label={`button-${props.label}`}
        _focus={{
          borderColor: 'brand',
          boxShadow: '0 0 0 2px #5bce4c',
          transform: 'scale(1.05)',
          transition: 'all 0.3s',
        }}
      >
        <RadioButton {...getInputProps()} ref={inputRef} />
        <Text>{props.label}</Text>
      </Box>
    </Box>
  )
}
